module.exports = __webpack_public_path__ + "static/media/clean-ginssen01.9ec3a8d9.jpg";